@if(acItem?.type !== 'advert') {
@if (model && model.data) {
<div class="pos-relative flex-column height-100 product-card">
    @switch (!!model.data.isBanner) {
    <!-- banner -->
    @default {
    <div class="p-b-1 p-b-0-m p-b-0-s flex-column height-100">
        <href class="pos-relative w-12 height-100 overflow-hidden banner-image"
              [link]="model.data.banner_url">
            <shell></shell>
            <img class="fill"
                 [attr.alt]="model.data.name"
                 [image]="bannerImage"
                 [ga4TrackClick]="ga4MenuNavigationData "
                 [acTrackClick]="(!listing && model) || undefined"
                 [acClickCode]="acClickCode">
        </href>
    </div>
    }
    <!-- product -->
    @case (false) {
    @switch (!!model.data.is_ob_bundle) {
    @case (true) {
    <div class="bg-col-4">
        <href class="w-12 "
              [link]="model.data.custom_url || model.data.url">
            <df-image-wrapper>
                <!-- take first image from media -->
                <img class="bg-col-4"
                     [ratio]="4/3"
                     [dfImage]="model.data.media?.[0]?.image || model.data.image"
                     [ga4TrackClick]="ga4MenuNavigationData"
                     [acTrackClick]="!listing && model || undefined"
                     [acClickCode]="acClickCode"
                     [attr.alt]="model.data.name">
            </df-image-wrapper>
        </href>
        <div class="m-t-7 p-t-2 p-l p-r p-b-8">
            <h4 class="h4">{{model.data.name}}</h4>
            <href class="m-t-1 inline-block linkLabel"
                  [link]="model.data.custom_url || model.data.url">{{'Shop This Look' | translate}}</href>
        </div>
    </div>
    }
    @default {
    <div (mouseenter)="onMouseIn()"
         (mouseleave)="onMouseOut()">
        <div class="pos-relative"
             (mouseenter)="onImageMouseIn()"
             (mouseleave)="onImageMouseOut()">
            @if (client.isCms) {
            <product-configurable-options-stock [product]="$any(model)">
            </product-configurable-options-stock>
            }
            <!-- single image product -->
            @if (!showSwiper) { <ng-container [ngTemplateOutlet]="comingSoonOverlayTpl"></ng-container>
            <!-- regular product -->
            <a class="w-12 "
               [routerLink]="model.data.url"
               [klevuTrackCategoryProductClick]="listing && klevuCategoryProductTrackClick"
               [klevuTrackRecommendationsProductClick]="listing && klevuRecommendationsProductClickData"
               [klevuTrackClick]="listing && klevuSearchTrackClick"
               [ga4TrackClick]="ga4MenuNavigationData"
               [acTrackClick]="!listing && model || undefined"
               [acClickCode]="acClickCode">
                <df-image-wrapper>
                    <img [ratio]="4/3"
                         [dfImage]="model.data.image"
                         [loaderParams]="{ format: 'webp' }"
                         [attr.alt]="model.data.name">
                </df-image-wrapper>


                <!-- add to basket -->
                <!-- <wishlist-add-to-basket class="pos-absolute bottom-2 right-2 z-4"
                [productId]="model.id"
              *ngIf="model.isSimple && !!wishlistItem"></wishlist-add-to-basket> -->
            </a>
            }
            <!-- multiple images product -->
            @if (showSwiper) {
            <div class="pos-relative overflow-hidden w-12 ratio-3-4">
                <shell></shell>
                @if(isBrowser) {
                <swiper class="fill _swiper"
                        [effect]="'fade'"
                        [pagination]="true"
                        [allowTouchMove]="canSlide"
                        #swiper>
                    @for (slide of carouselImages; track $index; let i = $index) {
                    <ng-template swiperSlide>
                        <a class="w-12"
                           [routerLink]="model.data.url"
                           [klevuTrackCategoryProductClick]="listing && klevuCategoryProductTrackClick || undefined"
                           [klevuTrackRecommendationsProductClick]="listing && klevuRecommendationsProductClickData || undefined"
                           [klevuTrackClick]="listing && klevuSearchTrackClick || undefined"
                           [ga4TrackClick]="ga4MenuNavigationData"
                           [acTrackClick]="!listing && model || undefined"
                           [acClickCode]="acClickCode">
                            @if (hadInteraction || !i) {
                            <df-image-wrapper>
                                <img [ratio]="4/3"
                                     [dfImage]="slide.image"
                                     [attr.alt]="model.data.name">
                            </df-image-wrapper>
                            }

                        </a> <ng-container [ngTemplateOutlet]="comingSoonOverlayTpl"></ng-container>
                    </ng-template>
                    }
                </swiper>
                <!-- custom dots -->
                <swiper-dots class="pos-absolute bottom-0 left-0 m-l-2 m-b-2 z-2"
                             [swiperRef]="swiper"></swiper-dots>
                }
            </div>
            }
            <!-- quick buy open button -->
            @if (isPreviewable && isQuickAddBtnVisible && !isComingSoonView && !model.isPos) {
            <product-quick-buy class="pos-absolute bottom-2 right-2 z-1"
                               [showAnimation]="!!showQuickBuyAnimation"></product-quick-buy>
            }
            <!-- quick buy view / X, L, M -->
            <ng-container *ifSize="'!S'">
                <ng-container [ngTemplateOutlet]="quickBuyView"></ng-container>
            </ng-container>
            <!-- quick buy view / S -->
            <ng-template #trayModalContent>
                <ng-container *ifSize="'S'">
                    <ng-container [ngTemplateOutlet]="quickBuyView"></ng-container>
                </ng-container>
            </ng-template>
        </div>
        <!-- label -->
        @if (model.label && !isComingSoonView) {
        <div class="pos-absolute p2 top-2 left-2 p-t-1 p-r-2 p-b-1 p-l-2 z-1"
             [ngStyle]="model.labelStyle || ''">
            {{model.label | translate}}
        </div>
        }
        <!-- add to wishlist -->
        @if(!isComingSoonView) {
        <ng-container *ifNotTradeStore>
            @switch (!!wishlistItem) {
            @case (false) {
            <wishlist-toggle [productId]="model.id"
                             class="pos-absolute top-2 right-2 z-1 product-wishlist"
                             [gridSize]="listing?.sizeState || 2">
            </wishlist-toggle>
            }
            @case (true) {
            <wishlist-remove class="pos-absolute top-2 right-2 z-1"
                             [item]="wishlistItem"></wishlist-remove>
            }
            }
        </ng-container>
        }
        <div class="m-t-3 p-b-1">
            <!-- configurable options -->
            <!-- REMOVED - cause of performance issues + this was never visible -->
            <!-- @if (!!wishlistItem) {
            @if (parent.isConfigurable) { -->
            <!-- <wishlist-product-configurable-options [product]="model"
                                                   [familyAttrs]="['color']"
                                                   (selectionChange)="matchExactly($event.data)">
            </wishlist-product-configurable-options> -->
            <!-- } -->
            <!-- } -->
            <!-- name -->
            <a [ngClass]="model.isOutOfStock ? 'col-12' : 'col-1'"
               sizeClass="!SM: p1, SM: p2"
               [routerLink]="model.data.url"
               [klevuTrackCategoryProductClick]="listing && klevuCategoryProductTrackClick || undefined"
               [klevuTrackRecommendationsProductClick]="listing && klevuRecommendationsProductClickData || undefined"
               [klevuTrackClick]="!!listing && klevuSearchTrackClick || undefined"
               [ga4TrackClick]="ga4MenuNavigationData "
               [acTrackClick]="!listing && model || undefined"
               [acClickCode]="acClickCode"
               cy-listingProductName>{{ model.data.name }}</a>
            <!-- Selected size in wishlist -->
            @if (!!wishlistItem) {
            <div class="p-t-2 flex-s flex-justify-between-s">
                @if (model.isConfigurable && model.configurableAttributeCodes?.includes('size')) {
                <p class="p2"
                   [ngClass]="model.isOutOfStock ? 'col-12' : 'col-1'">{{'No size selected' | translate}}
                </p>
                }
                @else {
                @if (model.data.size) {
                <span class="p2"
                      [ngClass]="model.isOutOfStock ? 'col-12' : 'col-1'">{{ 'Size' | translate }} {{model.data.size |
                    optionLabel :
                    'size'}}</span>
                }
                @if (model.isOutOfStock) {
                <span class="p2 p-l-2 col-2">{{'Out of stock' | translate}}</span>
                }
                }
            </div>
            }
            <!-- colours -->
            @if (swatchesCount) {
            <p class="m-t-1 col-12"
               sizeClass="!SM: p1, SM: p2">
                {{swatchesCount}} {{ (swatchesCount === 1 ? 'Colour' : 'Colours') | translate}}
            </p>
            }
            <!-- price -->
            <div class="m-t-1"
                 [ngClass]="model.isOutOfStock ? 'col-12' : 'col-1'"
                 sizeClass="!SM: p1, SM: p2">
                <ng-container *ifTradeStore>
                    <product-price-trade [product]="model"
                                         [variant]="'plp'"></product-price-trade>
                </ng-container>
                <ng-container *ifNotTradeStore>
                    @if (model.data.is_from_price) {
                    <span class="m-r-1">{{'from' | translate}}</span>
                    }
                    @if (canShowTieredPrice || !model.orgPrice) {
                    <product-price class="m-r-1 price"
                                   [product]="model"></product-price>
                    }
                    @if (model.orgPrice) {
                    <product-price class="line-through col-12"
                                   [product]="model"
                                   [orgPrice]="true"></product-price>
                    }
                </ng-container>
            </div>
            @if (parent?.data?.reviews) {
            <div class="flex flex-middle m-t-1"
                 style="margin-left: -0.14rem;">
                @if (parent?.data?.reviews?.rating) {
                <rating class="inline-flex fs-7-x fs-7-l"
                        [value]="(parent?.data?.reviews?.rating || 0) / 20"></rating>
                }
                @if (parent?.data?.reviews?.count) {
                <span class="m-l-2"
                      style="line-height: 1em;"
                      sizeClass="XL:p1, MS:p2">({{parent?.data?.reviews?.count}})</span>
                }
            </div>
            }
        </div>
    </div> }
    }
    }
    }
</div>
}
} @else {
@if (acItem) {
<advanced-commerce-listing-advert [item]="acItem" />
}
}

<ng-template #quickBuyView>
    @if (previewOpened) {
    <div class="pos-absolute bottom-0 left-2 right-2 z-5 bg-col-w p-a p-b-5 quick-add-to-basket"
         (offClick)="close()">
        <!-- close -->
        <button class="pos-absolute p-a top-0 right-0"
                type="button"
                [attr.aria-label]="'Close' | translate"
                (click)="close()">
            <i class="icon-close"
               aria-hidden="true"></i>
        </button>
        <!-- name -->
        <h4 class="h4 col-11 center m-t p-l-14 p-r-14 m-b-5-s">{{model.data?.name}}</h4>
        <div>
            <!-- configurable options -->
            <lp-product-configurable-options class="w-12 p-l-2 p-r-2 p-t-5 p-r-0-s p-b p-l-0-s center"
                                             [product]="$any(model)"
                                             [familyAttrs]="['color']"
                                             [color]="currentSwatchSelection"
                                             (selectionChange)="matchBest($event.data)" />
            @if (!model.isConfigurable) {
            <!-- in stock date -->
            <lp-product-in-stock-date [product]="model" />
            <!-- add to basket -->
            @if (!model.isComingSoon && !model.isComingSoonForced && !model.isBackSoon && !model.isSoldOut) {
            <lp-add-to-basket class="flex-column flex-column-reverse-s flex-grow-s"
                              [buyRequest]="request"
                              [product]="model"
                              [gtmAddToCartVia]="gtmAddToCartVia"
                              [qty]="model.minQty"
                              (success)="close()">
            </lp-add-to-basket>
            }
            <!-- notify me form  -->
            @if (isComingSoonView || model.isBackSoon) {
            <xnotif-form [model]="model"
                         (closeForm)="close()"></xnotif-form>
            }
            }
        </div>
    </div>
    }
</ng-template>

<ng-template #comingSoonOverlayTpl>
    @if (isComingSoonView) {
    <div class="fill z-3 pe-none"
         [style.background]="'rgba(235, 235, 235, 0.5)'"></div>
    <div class="pos-absolute top-50 left-50 z-4 p-t-3 p-b-3 p-l-2 p-r-2 _notifyBanner center">
        <p class="no-wrap"
           [sizeClass]="'XL: h2, SM: h4'">{{'Coming Soon' | translate}}</p>
        <!-- not standard button -->
        <button class="bg-col-1 m-t-3 flex flex-middle flex-justify-center _notifyButton col-w"
                (click)="togglePreview(true)">
            <i class="icon-email inline-flex m-r-3 m-r-2-s"
               style="font-size: 24px;"></i><span class="no-wrap"
                  [sizeClass]="'XL: p1, SM: p2'">{{'Notify Me' | translate}}</span>
        </button>
    </div>
    }
</ng-template>